import invite from "./module/invite";
import units from "./module/units";
import shares from "./module/share";
import unitsJava from "./module/unitsJava";
import invitePay from "./module/invitePay";
let [api, auth, httpCollect, apiJava, payApi] = "";
let newSignKeyAd = "945ceb69417c47ad87260f13c336213e"; // 安卓381新验签key
let newSignKeyIos = "f2086bbb0ad24e35b19f84c5d7ed6187"; // ios370新验签key
let signKey = "79e9a72c7d4611eebd1100163e381040"; //  350到380
let oldSignKey = "7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL"; //  老key
let newSignKeyAdV3 = "945ceb69417c47ad87260f13c336213e"; // 安卓381新验签key
let newSignKeyIosV3 = "f2086bbb0ad24e35b19f84c5d7ed6187"; // ios370新验签key
// 开发环境
if (process.env.NODE_ENV === "development") {
  api = "//user-api-dev.996box.com";
  apiJava = "//test-api.996box.com";
  auth = "//test-api.996box.com";
  payApi = "//pay-api-dev.996hezi.com";
  // share = "//boxuser-dev.dhsf.xqhuyu.com";
  httpCollect = `//box-collect.dev.xqhuyu.com`; // 埋点
  newSignKeyAd = "945ceb69417c47ad87260f13c336213e";
  newSignKeyIos = "f2086bbb0ad24e35b19f84c5d7ed6187";
  signKey = "79e9a72c7d4611eebd1100163e381040";
  oldSignKey = "7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL";
  newSignKeyAdV3 = "945ceb69417c47ad87260f13c336213e";
  newSignKeyIosV3 = "f2086bbb0ad24e35b19f84c5d7ed6187";
}
// 准生产环境
if (process.env.NODE_ENV === "pre") {
  api = "//user-api.pre.xqhuyu.com";
  auth = "//pre-api.996box.com";
  payApi = "//pay-api-pre.996box.com";
  // share = "//boxuser-dev.dhsf.xqhuyu.com";
  httpCollect = `//box-collect-pre.996hezi.com`; // 埋点
  newSignKeyAd = "52fe7708f58d11eebd1100163e381040";
  newSignKeyIos = "52fe770bf58d11eebd1100163e381040";
  signKey = "8e12130c7d4611eebd1100163e381040";
  oldSignKey = "7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL";
  newSignKeyAdV3 = "9BA29C70F29340CAA7F0D66BA0E6C26A";
  newSignKeyIosV3 = "FD2778502C8F469FAD4C2DF5FEA8C545";
}
// 正式环境
if (process.env.NODE_ENV === "production") {
  api = "//user-api.996box.com";
  auth = "//api.996box.com";
  payApi = "//pay-api.996box.com";
  // share = "//boxuser-dev.dhsf.xqhuyu.com";
  httpCollect = `//box-collect.xqhuyu.com`; // 埋点
  newSignKeyAd = "52fe7708f58d11eebd1100163e381040";
  newSignKeyIos = "52fe770bf58d11eebd1100163e381040";
  signKey = "8e12130c7d4611eebd1100163e381040";
  oldSignKey = "7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL";
  newSignKeyAdV3 = "A231C95BD99D42639E2CC2D19804DE8C";
  newSignKeyIosV3 = "D9A55458219F40888FFB7D777C7FDD2A";
}
const httpList: any = {
  user: { ...invite(`${api}`) },
  auth: { ...units(`${auth}`) },
  share: { ...shares(`${api}`) },
  unitsJava: { ...unitsJava(`${auth}`) },
  invitePay: { ...invitePay(`${payApi}`) },
  // 埋点
  collect: {
    collect: `${httpCollect}/v1/newLog`,
  },
  newSignKeyAd,
  newSignKeyIos,
  signKey,
  oldSignKey,
  newSignKeyAdV3,
  newSignKeyIosV3,
};

export default httpList;
